// import node module libraries
import { Fragment } from 'react';
import { Container } from 'react-bootstrap';

// import custom components
import LogosTopHeading from 'components/marketing/common/clientlogos/LogosTopHeading';
import CTAButton from 'components/marketing/common/call-to-action/CTAButton';

// import sub components
import HeroTyped from './HeroTyped';
import Features4Columns from './Features4Columns';
import PricingPlans from './PricingPlans';
import BrowseFlows from './BrowseFlows';
import FAQsection from './FAQsection';

import SEO from 'components/marketing/seo/Seo';

// import layouts
import NavbarHaeppyapp from 'layouts/marketing/navbars/NavbarHaeppyapp';
import FooterHaeppyapp from 'layouts/marketing/footers/FooterHaeppyapp';

// import required data files
import LogoList2 from 'data/marketing/clientlogos/LogoList2';

// import translation
import { useTranslation } from 'react-i18next';

const LandingHaeppy = () => {
	const { t } = useTranslation();

	return (
		<Fragment>
			<SEO
				title="E-Commerce Multi-Channel Schnittstellen automatisieren"
				description="Automatisiere deine Marktplatz-Anbindungen mit haeppy.app – die SaaS-Plattform für effiziente Multi-Channel-Prozesse im E-Commerce. Jetzt testen!"
				keywords="multi channel schnittstelle, e-commerce schnittstelle, marktplatzanbindung"
				canonical="https://haeppy.app/"
			/>
			<NavbarHaeppyapp
				transparent={true}
				center={false}
			/>
			<main>
				{/* Page Content */}
				<section className="">
					<HeroTyped />
				</section>

				{/*  Featured in section 
				<LogosTopHeading title="Featured In" logos={LogoList2} />
				*/}
				{/* Features */}
				<Features4Columns />

				{/* PricingPlans */}
				<PricingPlans />

				{/* Browse Connectors */}
				<BrowseFlows />

				{/*  FAQs section */}
				<FAQsection />
			</main>


			{/* Hero Call to Action */}

			{/*  CTA section */}
			<CTAButton
				title={t('Start right now for free with our SaaS platform')}
				description={t('Start right now with our platform.free package and automate your e-commerce processes.')}
				btntext={t('Start now for free')}
				btnlink="/authentication/sign-up"
			/>

		</Fragment>
	);
};
export default LandingHaeppy;
